import { Cloud, Cpu, FileText, Settings, Wand2 } from 'lucide-react';

export function HowItWorks() {
  return (
    <section className="py-20 sm:py-32 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-xl text-center mb-12">
          <h2 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl">
            Streamlined Legal Workflow
          </h2>
          <p className="mt-4 text-xl text-gray-600">From AI sources to professional deliverables</p>
        </div>

        <div className="mx-auto max-w-5xl">
          {/* Workflow Image */}
          <div className="mb-12">
            <img
              src="/workflows.jpg"
              alt="SafeIdea workflow: AI sources to structured legal tools to professional deliverable"
              className="w-full rounded-lg shadow-lg"
            />
          </div>

          {/* Three columns explanation */}
          <div className="grid gap-8 md:grid-cols-3">
            <div className="bg-white rounded-lg p-6 border border-gray-200">
              <div className="flex items-center gap-3 mb-4">
                <div className="h-10 w-10 rounded-lg bg-blue-100 flex items-center justify-center">
                  <Cpu className="h-5 w-5 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900">AI Sources</h3>
              </div>
              <ul className="space-y-3 text-gray-600 text-base">
                <li className="flex items-start gap-2">
                  <Cpu className="h-4 w-4 text-gray-400 mt-0.5 flex-shrink-0" />
                  <span>
                    <strong>Local AI</strong> — Runs on your PC, zero marginal cost, works offline
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <Cloud className="h-4 w-4 text-gray-400 mt-0.5 flex-shrink-0" />
                  <span>
                    <strong>Frontier AI</strong> — Claude from Anthropic, via deidentification layer
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-lg p-6 border border-gray-200">
              <div className="flex items-center gap-3 mb-4">
                <div className="h-10 w-10 rounded-lg bg-blue-100 flex items-center justify-center">
                  <Settings className="h-5 w-5 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900">Legal AI Tools</h3>
              </div>
              <ul className="space-y-3 text-gray-600 text-base">
                <li className="flex items-start gap-2">
                  <Wand2 className="h-4 w-4 text-gray-400 mt-0.5 flex-shrink-0" />
                  <span>
                    <strong>Pre-built workflows</strong> for common legal tasks
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <Settings className="h-4 w-4 text-gray-400 mt-0.5 flex-shrink-0" />
                  <span>
                    <strong>Custom workflows</strong> you define for your practice
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <FileText className="h-4 w-4 text-gray-400 mt-0.5 flex-shrink-0" />
                  <span>
                    <strong>Document transformation</strong> with automated processing
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-lg p-6 border border-gray-200">
              <div className="flex items-center gap-3 mb-4">
                <div className="h-10 w-10 rounded-lg bg-blue-100 flex items-center justify-center">
                  <FileText className="h-5 w-5 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900">Deliverable</h3>
              </div>
              <p className="text-gray-600 text-base">
                Usable output ready for client work. Drafts, analyses, research memos, and other
                work product formatted for your practice.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
